import { render, staticRenderFns } from "./activation.vue?vue&type=template&id=350637c1&scoped=true&"
import script from "./activation.vue?vue&type=script&lang=js&"
export * from "./activation.vue?vue&type=script&lang=js&"
import style0 from "./activation.vue?vue&type=style&index=0&id=350637c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350637c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350637c1')) {
      api.createRecord('350637c1', component.options)
    } else {
      api.reload('350637c1', component.options)
    }
    module.hot.accept("./activation.vue?vue&type=template&id=350637c1&scoped=true&", function () {
      api.rerender('350637c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/usermgmt/activation.vue"
export default component.exports